<template>
  <div
    ref="overlay"
    role="dialog"
    aria-label="Tito Widget"
    class="tito-overlay"
    @mousedown="prepForClose($event)"
    @mouseup="closeViaOverlay($event)"
  >
    <transition
      appear
      v-bind:key="$route.params.registrationId"
      v-on:before-enter="beforeEnter"
      v-on:enter="enter"
      v-on:leave="leave"
      v-bind:css="false"
    >
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import canClose from "js/src/mixins/canClose.js";
import Velocity from "velocity-animate";

export default {
  mixins: [canClose],
  name: "InlineOverlay",

  data() {
    return {
      closeOnMouseUp: null,
      scrollTop: null,
    };
  },
  computed: {
    confirmCloseMessage() {
      if(this.joiningWaitingList()) {
        return this.$t("js.confirm_join_waiting_list_cancel");
      } else if(this.isRegistrationFinished()) {
        return this.$t("js.confirm_order_close");
      } else {
        return this.$t("js.confirm_order_cancel");
      }
    },

    registration() {
      return this.$store.getters["registration/find"](
        this.$route.params.registrationId
      );
    },

    closeUrl() {
      if(this.registration && this.registration.finished && (this.registration.close_url || this.registration.redirect_url)) {
        return this.registration.close_url || this.registration.redirect_url;
      }
    }
  },
  methods: {
    close() {
      if(this.closeUrl) {
        if (window.parent == window) {
          document.location.href = this.closeUrl;
        } else {
          window.parent.postMessage({
            action: "redirect",
            url: this.closeUrl,
          }, "*")
        }
      } else {
        this.$router.push({ path: "/" });
      }
    },
    closeViaOverlay(event) {
      const noScrollChange = this.$refs.overlay.scrollTop == this.scrollTop;
      if(this.closeOnMouseUp && this.canClose && noScrollChange) {
        if(this.confirmClose()) {
          this.close();
        }
      }
    },
    confirmClose() {
      return confirm(this.confirmCloseMessage);
    },
    beforeEnter(el) {
      Velocity(el, { scale: 0, opacity: 0 }, { duration: 0 });
      this.ready = true;
    },
    enter(el, done) {
      Velocity(
        el,
        { scale: 1, opacity: 1 },
        { easing: "easeInSine", duration: 250, done: done }
      );
    },
    async leave(el, done) {
      await Velocity(el, { translateY: 1000, opacity: 0 }, { duration: 250 });
      done();
    },
    isOverlayClick(event) {
      return event.target == this.$refs.overlay;
    },
    isOverlayScrollbarClick(event) {
      return (
        event.clientX >= document.getElementById("tito-overlay").offsetWidth
      );
    },
    isRegistrationFinished() {
      return !!(this.registration && this.registration.finished);
    },
    prepForClose(event) {
      this.scrollTop = this.$refs.overlay.scrollTop;
      this.closeOnMouseUp =
        this.isOverlayClick(event) && !this.isOverlayScrollbarClick(event);
    },

    joiningWaitingList() {
      return this.$route.name == "newWaitlistedPerson";
    },
  },
};
</script>
